export const ENTITY_STATUS = {
  ACTUAL: 'actual',
  DEPRECATED: 'deprecated',
  ARCHIVED: 'archived',
};

// Порядок блоков в списке: сначала актуальные, архивные всегда внизу.
export const ENTITY_STATUS_ORDER = [
  ENTITY_STATUS.ACTUAL,
  ENTITY_STATUS.DEPRECATED,
  ENTITY_STATUS.ARCHIVED,
];

// Состояние называется прилагательным и согласуется с предметом:
// «архивная» мебель, «архивный» молдинг. Голого «Архива» нет нигде.
const STATUS_FORMS = {
  [ENTITY_STATUS.ACTUAL]: {
    f: 'Актуальная', m: 'Актуальный', n: 'Актуальное', p: 'Актуальные',
  },
  [ENTITY_STATUS.DEPRECATED]: {
    f: 'Устаревшая', m: 'Устаревший', n: 'Устаревшее', p: 'Устаревшие',
  },
  [ENTITY_STATUS.ARCHIVED]: {
    f: 'Архивная', m: 'Архивный', n: 'Архивное', p: 'Архивные',
  },
};

const STATUS_COLORS = {
  [ENTITY_STATUS.ACTUAL]: 'green',
  [ENTITY_STATUS.DEPRECATED]: 'gold',
  [ENTITY_STATUS.ARCHIVED]: 'default',
};

// Род существительного, к которому относится состояние: мебель — женский,
// материал — мужской. Используется только для подписи в строке таблицы.
export const ENTITY_GENDER = {
  furniture: 'f',
  svgFurniture: 'f',
  material: 'm',
  aperture: 'f',
  molding: 'm',
  roomType: 'm',
};

export const statusLabel = (status, gender = 'f') => STATUS_FORMS[status]?.[gender] ?? '';

export const statusPluralLabel = (status) => STATUS_FORMS[status]?.p ?? '';

export const statusColor = (status) => STATUS_COLORS[status] ?? 'default';

export const statusOptions = () => ENTITY_STATUS_ORDER.map((value) => ({
  value,
  label: statusPluralLabel(value),
}));

// Порядковый вес состояния для сортировки блоками.
export const statusWeight = (status) => {
  const index = ENTITY_STATUS_ORDER.indexOf(status);

  return index === -1 ? ENTITY_STATUS_ORDER.length : index;
};

// Проставляет состояние записям выборки, пришедшей отдельным запросом:
// мебель и материалы отдают каждое состояние своим запросом.
export const withStatus = (items, status) => (items ?? []).map((item) => ({ ...item, status }));

// Выводит состояние из полей записи: апертуры и молдинги приходят одним
// запросом «с корзиной», состояние читается из deleted_at и is_deprecated.
export const resolveStatus = (item) => {
  if (item?.deleted_at) return ENTITY_STATUS.ARCHIVED;
  if (item?.is_deprecated || item?.deprecated) return ENTITY_STATUS.DEPRECATED;

  return ENTITY_STATUS.ACTUAL;
};

export const sortByStatus = (items) => [...(items ?? [])].sort((a, b) => {
  const diff = statusWeight(a.status) - statusWeight(b.status);

  if (diff !== 0) return diff;

  return String(a.name ?? '').localeCompare(String(b.name ?? ''), 'ru');
});
